<template>
  <div :menu-fix="true">
    <div class="wrapper">
      <breadcrumb
        :crumbs="[$t('menu.reports'), $t('reports.wmsInventoryCount')]"
      >
      </breadcrumb>
    </div>
    <div class="search">
      <el-form
        :inline="true"
        @submit.native.prevent="search"
        :model="searchForm"
        size="small"
        label-width="110px"
      >
        <el-form-item :label="$t('menu.warehouses')">
          <el-checkbox-group v-model="searchForm.shopIds">
            <el-checkbox
              v-for="(shop, index) of shops"
              :key="index"
              :label="shop.id"
              >{{ shop.name }}</el-checkbox
            >
          </el-checkbox-group>
        </el-form-item>
        <br />
        <el-form-item :label="$t('menu.categories')">
          <el-checkbox-group v-model="searchForm.categoryIds">
            <el-checkbox
              v-for="category of categories"
              :key="category.id"
              :label="category.id"
            >
              {{ category.name }}
            </el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <br />
        <el-form-item :label="' '">
          <el-button
            type="primary"
            icon="el-icon-search"
            native-type="submit"
            >{{ $t("text.search") }}</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <div class="wrapper table-area">
      <!-- <sticky
        :sticky-top="50"
        :viewport="1024"
        :is-rem="false"
        style="min-height: 52px"
      >
        <vxe-toolbar ref="recordsToolbar" zoom class="table-toolbar">
          <template v-slot:buttons>
            <el-button type="default" size="mini" @click="download">
              {{ $t("action.download") }}
            </el-button>
          </template>
        </vxe-toolbar>
      </sticky> -->
      <vxe-table
        :data="records"
        :loading="loading"
        ref="recordsTable"
        class="recordsTable"
        size="mini"
        resizable
        round
        auto-resize
        highlight-hover-row
        :scroll-y="{ enabled: false }"
      >
        <vxe-table-column
          field="shopName"
          :title="$t('menu.warehouses')"
          min-width="80"
        />
        <vxe-table-column
          field="productNoQty"
          :title="$t('report.productQty')"
          min-width="80"
        />
        <vxe-table-column
          field="qtyTotal"
          :title="$t('bargain.productQty')"
          min-width="80"
        />

        <vxe-table-column field="saleTotal" :title="'货值额'" min-width="110">
          <template v-slot="{ row }">
            {{ row.saleTotal | currency }}
          </template>
        </vxe-table-column>
        <vxe-table-column field="costTotal" :title="'成本额'" min-width="110">
          <template v-slot="{ row }">
            {{ row.costTotal | currency }}
          </template>
        </vxe-table-column>
      </vxe-table>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import { page } from "@/utils/mixins.js";
import DateRange from "@/components/DateRange";
import Category from "@/api/category";
import Shop from "@/api/shop";
import Inventory from "@/api/inventory";

export default {
  mixins: [page],
  components: { DateRange },
  data() {
    return {
      searchForm: {
        shopIds: [],
        categoryIds: [],
      },
      categories: [],
      shops: [],
      //
      records: [],
      totals: [],
      loading: false,
    };
  },

  created() {
    const self = this;
    axios.all([Shop.findByTenantId(), Category.findByTenantId()]).then(
      axios.spread(function (shops, categories) {
        if (shops.status == 200) {
          self.shops = shops.data.filter((s) => s.isInventory == true);
        } else {
          self.sysError();
        }
        if (categories.status == 200) {
          self.categories = categories.data;
        } else {
          self.sysError();
        }
      })
    );
  },
  methods: {
    //
    // download() {
    //   const self = this;
    //   if (
    //     self.searchForm.shopIds.length == 0 &&
    //     self.searchForm.categoryIds.length == 0
    //   ) {
    //     this.$message({
    //       message: "至少选择一个条件",
    //       type: "warning",
    //     });
    //     return;
    //   }
    //   if (self.records.length == 0) {
    //     this.$message({
    //       message: self.$t("text.noData"),
    //       type: "warning",
    //     });
    //     return;
    //   }
    //   // Inventory.reportExportExcel(self.combineParams()).then(function (
    //   //   res
    //   // ) {
    //   //   if (res.status === 200) {
    //   //     self.$message({
    //   //       message: self.$t("prompt.downloadPrompt"),
    //   //       type: "success",
    //   //     });
    //   //     self.checkedRows = [];
    //   //     self.$eventHub.$emit("emitDownLoad");
    //   //   } else {
    //   //     self.$message.error(self.$t("prompt.downloadErr"));
    //   //   }
    //   // });
    // },
    search() {
      const self = this;
      if (
        self.searchForm.shopIds.length == 0 &&
        self.searchForm.categoryIds.length == 0
      ) {
        this.$message({
          message: "至少选择一个条件",
          type: "warning",
        });
        return;
      }
      self.loading = true;
      Inventory.report(self.combineParams()).then(function (res) {
        self.loading = false;
        if (res.status === 200) {
          self.records = res.data;
        } else {
          self.sysError();
        }
      });
    },
    //
    combineParams() {
      let params = {};
      if (this.searchForm) {
        for (let key in this.searchForm) {
          if (
            this.searchForm[key] &&
            JSON.stringify(this.searchForm[key]) != "[]"
          ) {
            params[key] = this.searchForm[key];
          }
        }
      }
      return params;
    },
  },
};
</script>
<style >
.el-form-item__content {
  height: auto !important;
}
</style>